import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    authenticated: false,
    doLogout: false,
    user: null,
    tenant: null,
    tenantSettings: null,
    envName: null,
    refreshLoggedInUser: false
};
export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        changeAuthenticated: (state, action) => {
            state.authenticated = action.payload;
        },
        changeDoLogout: (state, action) => {
            state.doLogout = action.payload;
        },
        changeUser: (state, action) => {
            state.user = action.payload;
        },
        changeTenant: (state, action) => {
            state.tenant = action.payload;
        },
        changeTenantSettings: (state, action) => {
            state.tenantSettings = action.payload;
        },
        changeEnvName: (state, action) => {
            state.envName = action.payload;
        },
        changeRefreshLoggedInUser: (state, action) => {
            state.refreshLoggedInUser = action.payload;
        },
    }
});
export const { changeAuthenticated, changeDoLogout, changeUser, changeTenant, changeTenantSettings, changeEnvName, changeRefreshLoggedInUser } = authSlice.actions;
export const doLogoutSelector = (state) => state?.auth.doLogout ?? false;
export const authenticatedSelector = (state) => state?.auth?.authenticated ?? false;
export const loggedInUserSelector = (state) => state?.auth?.user ?? null;
export const selectedTenantSelector = (state) => state?.auth?.tenant ?? null;
export const selectedTenantSettingsSelector = (state) => state?.auth?.tenantSettings ?? null;
export const refreshLoggedInUserSelector = (state) => state?.auth?.refreshLoggedInUser ?? false;
export const envNameSelector = (state) => state?.auth?.envName ?? null;
export default authSlice.reducer;
